import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    'Authorization': 'Bearer ' + ActionsLogin.getToken()
  }
}

const url = process.env.URL_API_BASE

const cadastrar = ({ descricao, idc_status, idc_possui_numero_viagens, idc_possui_segmentos, idc_usa_imagem }) => {
  return axios.post(url + '/aplicativo', {
    descricao: descricao,
    idc_status: idc_status,
    idc_possui_numero_viagens: idc_possui_numero_viagens,
    idc_possui_segmentos: idc_possui_segmentos,
    idc_usa_imagem: idc_usa_imagem,

    created_by: ActionsLogin.getUsuario().cd_usuario
  }, config)
}

const alterar = ({ id, descricao, idc_status, idc_possui_numero_viagens, idc_possui_segmentos, idc_usa_imagem }) => {
  return axios.patch(url + '/aplicativo/' + id, {
    descricao: descricao,
    idc_status: idc_status,
    idc_possui_numero_viagens: idc_possui_numero_viagens,
    idc_possui_segmentos: idc_possui_segmentos,
    idc_usa_imagem: idc_usa_imagem,
    updated_by: ActionsLogin.getUsuario().cd_usuario
  }, config)
}

const listar = async () => {
  let response = await axios.get(url + '/aplicativo', config)

  return response.data
}

const listarAtivos = async () => {
  let response = await axios.get(url + '/aplicativo/listar-ativos/1', config)

  return response.data
}

export const obter = async (id) => {
  let response = await axios.get(url + '/aplicativo/' + id, config)

  return response.data
}

export default {
  cadastrar,
  alterar,
  listar,
  listarAtivos,
  obter
}



// WEBPACK FOOTER //
// ./src/actions/AplicativoActions.js